import { PlanType } from '@/graphql'

import useLoggedInUser from './useLoggedInUser'

const useActiveSubscription = () => {
  const { user, loading } = useLoggedInUser()
  const subscription = user?.activeSubscription
  const isBasic =
    subscription !== PlanType.PREMIUM &&
    subscription !== PlanType.ENTERPRISE &&
    subscription !== PlanType.PREMIUM_FREE
  const isPremium =
    subscription === PlanType.PREMIUM || subscription === PlanType.PREMIUM_FREE
  const isEnterprise = subscription === PlanType.ENTERPRISE
  return { loading, isBasic, isPremium, isEnterprise, subscription }
}

export default useActiveSubscription
